import { Loader2 } from 'lucide-react';
import { MarketButtons } from '../MarketButtons';

export const inputCls = 'w-full bg-black border border-zinc-800 rounded-md px-3 py-2.5 text-sm text-white placeholder-zinc-600 focus:outline-none focus:border-brand/60 transition-colors';
export const labelCls = 'block text-[11px] font-mono uppercase tracking-wider text-zinc-500 mb-1.5';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TickerPicker = ({ prefix, market, setMarket, ticker, setTicker, onSubmit, loading, disabled, cta }) => (
  <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-3 items-end">
    <div className="sm:col-span-2">
      <label className={labelCls}>Market</label>
      <MarketButtons value={market} onChange={setMarket} prefix={prefix} compact />
    </div>
    <div>
      <label className={labelCls}>Ticker</label>
      <input
        value={ticker}
        onChange={(e) => setTicker(e.target.value.toUpperCase())}
        onKeyDown={(e) => { if (e.key === 'Enter' && !disabled) onSubmit(); }}
        placeholder="e.g. AAPL, BHP"
        maxLength={10}
        className={`${inputCls} font-mono`}
        data-testid={`${prefix}-ticker-input`}
      />
    </div>
    <button
      onClick={onSubmit}
      disabled={disabled || loading}
      className="bg-brand hover:bg-brand-light text-black text-sm font-bold px-5 py-2.5 rounded-md transition-colors disabled:opacity-30 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
      data-testid={`${prefix}-submit-btn`}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : cta}
    </button>
  </div>
);

export const ErrorNote = ({ error, testId }) => error ? (
  <p className="text-xs text-red-400 bg-red-500/5 border border-red-500/20 rounded-md p-3" data-testid={testId}>{error}</p>
) : null;

export const fetchJson = async (url, opts) => {
  const res = await fetch(url, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Request failed. Please try again.');
  return data;
};

export const fmt = (n, d = 2) => Number(n).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
